import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const StyledFooter = styled.div`
    margin-top: 100px;
    font-size: small;
    padding-top: 10px;
    border-top: 1px solid #eeeeee;
    position: relative;
    display: block;
    color: dimgrey;

    button {
        font-size: small;
        margin-top: -2px !important;
    }
`

const roles = {
    '1': 'Super Admin',
    '2': 'Admin',
    '3': 'Manager',
    '4': 'Editor',
    '5': 'User'
}

const Footer = (props) => {
    return (
        <StyledFooter>
            {!!props.user &&
                <div className="mb-4">
                    You are logged in as
                    <strong> {props.user.name} </strong>({roles[props.user.role]})
                    <span> | </span>
                    <Link to="/logout">Logout</Link>
                </div>
            }
        </StyledFooter>
    )
}

export default Footer